import * as React from "react";
const SvgForward = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.83334 15L12.8333 10L7.83334 5L6.66668 6.16667L10.5 10L6.66668 13.8333L7.83334 15Z", fill: "currentColor" }));
export default SvgForward;
